<template>
  <v-fade-transition
    :hide-on-leave="hideOnLeave"
    mode="out-in"
    origin="center"
    appear
  >
    <div
      data-qa="file_preview"
      class="file-preview"
    >
      <div
        data-qa="file_preview_wrapper"
        class="file-preview__wrapper"
      >
        <div
          data-qa="file_preview_image_wrapper"
          class="file-preview__image-wrapper"
        >
          <img
            v-if="previewSrc"
            :src="previewSrc"
            data-qa="file_preview_image"
            class="file-preview__image"
          >
        </div>

        <DeleteBtn
          class="file-preview__button-wrapper"
          @click="emit('delete')"
        />

        <v-fade-transition
          mode="out-in"
          origin="center"
          appear
        >
          <StatusIcon
            :key="status"
            class="file-preview__status-icon"
            :status="status"
            :file-mime-type="file.type"
            :progress-value="progressValue"
            @click="handleClickStatusIcon"
          />
        </v-fade-transition>
      </div>

      <v-fade-transition
        mode="out-in"
        origin="center"
        appear
      >
        <div
          v-if="descriptionData"
          :key="status"
          data-qa="file_preview_description"
          class="pt-1 text-caption text-center"
          :class="descriptionData.classes"
        >
          {{ descriptionData.text }}
        </div>
      </v-fade-transition>
    </div>
  </v-fade-transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Status } from 'src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/types'
import usePreviewSrc from 'src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/components/FilePreview/composables/usePreviewSrc'
import DeleteBtn from 'src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/components/FilePreview/components/DeleteBtn.vue'
import StatusIcon from 'src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/components/FilePreview/components/StatusIcon.vue'

const props = defineProps<{
  file: File
  size: number | string
  status: Status
  progressValue?: number | string
  hideOnLeave?: boolean
}>()

type Emits = {
  (_e: 'delete'): void
  (_e: 'retry'): void
}

const emit = defineEmits<Emits>()

function handleClickStatusIcon() {
  if (props.status === 'fail') {
    emit('retry')
  }
}

const descriptionData = computed(() => {
  switch (props.status) {
    case 'fail':
      return {
        text: 'Не загружен',
        classes: 'text-error--text',
      }
    case 'loading':
      return {
        text: 'Загрузка',
        classes: 'text-info--text',
      }
    default:
      return null
  }
})

const { previewSrc } = usePreviewSrc({
  file: props.file,
  size: props.size,
})
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';
@import '~www/themes/doctors/common/mixins';

.file-preview {
  &__wrapper {
    position: relative;
    width: 100%;
  }

  &__image-wrapper {
    width: 100%;
    height: 100%;
    border: 1px solid $ui-kit-bg-gray-60;
    border-radius: $border-radius-md;
    overflow: hidden;
  }

  &__image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__button-wrapper {
    position: absolute;
    transform: translate(50%, -50%);
    top: 4px;
    right: 4px;
  }

  &__button {
    background-color: $ui-kit-bg-gray-0;
  }

  &__status-icon {
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
